import { createContext } from 'react';
const AnimatingContext = createContext();
export default AnimatingContext;
